import { Injectable, Injector } from '@angular/core';
import { CanMatch, Data, Route } from '@angular/router';
import { UserProfileService } from '../user-profile.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanMatch {
  protected userService: UserProfileService;

  constructor(private readonly _childInjector: Injector) {
    this.userService = _childInjector.get(UserProfileService);
  }

  public canMatch(route: Route): boolean {
    if (route.data === undefined) {
      return false;
    }
    const { roles, every } = this.getRoleData(route.data);
    const canActivate = this.userService.checkRoles(roles, every);

    return canActivate;
  }

  protected getRoleData(route: Data): {
    roles: string[];
    every: boolean;
  } {
    const roles = route['roles'] ?? [];
    const every = route['every'] ?? false;

    return { roles, every };
  }
}
